import { CgNotes } from "react-icons/cg";
import { IoClose } from "react-icons/io5";

const SendNotesDialog = ({
  open,
  onClose,
  handleSend,
  diagnosis,
  suggest,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/10 backdrop-blur-sm">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <div className="flex items-center gap-2">
            <span className="text-blue-600 text-lg">
              <CgNotes />
            </span>
            <h2 className="font-semibold text-slate-700 text-xl">
              Catatan Dokter
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-error transition"
          >
            <IoClose size={20} />
          </button>
        </div>

        <div className="px-6 py-5 space-y-6">
          <div>
            <h1 className="block text-base font-semibold text-slate-700 mb-2">
              Diagnosa
            </h1>
            <p className="text-slate-500 font-medium text-md">{diagnosis}</p>
          </div>

          <div>
            <h1 className="block text-base font-semibold text-slate-700 mb-2">
              Saran & Anjuran
            </h1>

            <div className="text-slate-500 font-medium text-md">
              {suggest.length > 0 && (
                <ul className="list-disc ml-5 space-y-1">
                  {suggest.map((sgt, i) => (
                    <li key={i} className="leading-tight">
                      {sgt}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="w-full">
            <p className="italic text-sm text-error">
              *Catatan dokter hanya bisa dikirim 1x ke pasien, pastikan bahwa
              catatan sudah benar.
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-2 px-6 py-4 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border text-md text-gray-600 hover:bg-slate-100 transition"
          >
            Batal
          </button>

          <button
            onClick={handleSend}
            className="px-4 py-2 rounded-lg text-md font-medium text-white transition bg-secondary hover:bg-secondaryHover"
          >
            Kirim Catatan
          </button>
        </div>
      </div>
    </div>
  );
};

export const buildNotesText = (doctorName, diagnosa, saranList) => {
  const filledSaran = saranList.filter((s) => s.trim() !== "");
  if (!diagnosa.trim() && filledSaran.length === 0) return "";

  const saranLines = filledSaran.map((s) => `• ${s.trim()}`).join("\n");

  return (
    `Halo! Saya ${doctorName}. 👋\n\n` +
    `📋 Catatan\n\n` +
    `Diagnosa: ${diagnosa.trim()}\n` +
    saranLines
  );
};

export default SendNotesDialog;
